export default "__VITE_ASSET__BINZlmR9__"